import { useMemo } from "react";
import isEqual from "lodash/isEqual";

const SECCION_PATHS = {
  portada: [
    "solicitanteId",
    "solicitanteNuevo",
    "sucursal",
    "fecha",
    "titulo",
    "descripcion",
  ],
  quienesSomos: ["introduccion", "resumenEjecutivo"],
  antecedentes: ["antecedentes"],
  estructura: ["alcance"],
  fasesServicios: ["items"],
  equipo: ["vendedor", "supervisor", "equipo"],
  infoAdicional: [
    "condicionesPago",
    "duracionEstimada",
    "proximosPasos",
    "clausulaConfidencialidad",
  ],
};

/**
 * Devuelve un objeto booleano con el estado dirty por sección, comparando
 * values vs initialValues sobre los paths asignados a cada sección.
 */
export const useSectionDirty = (values, initialValues) =>
  useMemo(() => {
    const result = {};
    for (const [seccion, paths] of Object.entries(SECCION_PATHS)) {
      result[seccion] = paths.some(
        (p) => !isEqual(values[p], initialValues[p]),
      );
    }
    return result;
  }, [values, initialValues]);

export { SECCION_PATHS };
